import { render } from "./ThePatientListProfessionals.vue?vue&type=template&id=39d97b18&scoped=true&ts=true"
import script from "./ThePatientListProfessionals.vue?vue&type=script&lang=ts"
export * from "./ThePatientListProfessionals.vue?vue&type=script&lang=ts"

import "./ThePatientListProfessionals.vue?vue&type=style&index=0&id=39d97b18&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d97b18"]])

export default __exports__